// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D2uU2smdL3ge037_hfxb{cursor:pointer}`, "",{"version":3,"sources":["webpack://./node_modules/aphrodite.react/Components/Inputs/Autocomplete.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA","sourcesContent":[".suggestion{cursor:pointer}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suggestion": `D2uU2smdL3ge037_hfxb`
};
export default ___CSS_LOADER_EXPORT___;
